export default __webpack_public_path__ + "static/home-5bdebf772ec72c9e21816ec5d4c7fa69.png";